import * as types from "../constants/action_types";

const initialState = {};

function user(state = initialState, action) {
  switch (action.type) {
  case types.UPDATE_USER:
  case types.FETCH_USER:
    return Object.assign({}, action.user);
  case types.UPDATE_INVESTMENTS:
    return Object.assign({}, state, action.investments);
  case types.UPDATE_CAREERS:
    return Object.assign({}, state, action.careers);
  case types.UPDATE_TWITTER_LINK:
    return Object.assign({}, state, { twitter_url: action.twitter.url });
  default:
    return state;
  }
}

export default user;
